export class LogoutEvent<T> extends CustomEvent<T> {
  // Called when api is failed to refresh tokens
  public static readonly NAME = 'api:logout';

  public constructor(eventInitDict?: CustomEventInit<T>) {
    super(LogoutEvent.NAME, eventInitDict);
  }
}
